// extracted by mini-css-extract-plugin
export default {"feed":"feed_feed__axu3E"};